export class Bonus {
  id: string;
  name: string;
  truffleType: string;
  weight: number;
  createdAt: string = new Date().toString();
  fieldId: string;
  description: string;
}
